import { render, staticRenderFns } from "./board_column.vue?vue&type=template&id=65c3283e&"
import script from "./board_column.vue?vue&type=script&lang=js&"
export * from "./board_column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports